import type { PageRef } from '@wix/editor-platform-sdk-types'
import {
  addPattern,
  deletePattern,
  getPatternDefForPage,
  MAIN_SLUG_PATTERN,
} from '@wix/wix-data-client-common'
import type {
  DynamicPageRouterData,
  PatternDefinition,
} from '@wix/wix-data-client-common-standalone'

const createNewPatternDefinition = (
  oldPatternDef: PatternDefinition,
  newCollectionId: string,
) => {
  const { collection, sort, filter, ...oldConfigBase } = oldPatternDef.config
  return {
    ...oldPatternDef,
    config: {
      ...oldConfigBase,
      collection: newCollectionId,
    },
  }
}

export const prepareRouteData = async ({
  oldRouter,
  pageRef,
  newCollectionId,
}: {
  oldRouter: DynamicPageRouterData
  pageRef: PageRef
  newCollectionId: string
}) => {
  const patternCount = Object.keys(oldRouter.config.patterns).length
  if (patternCount > 1) {
    throw new Error('Not implemented for routers with multiple patterns')
  }

  const { pattern: oldPattern, def: oldPatternDef } = getPatternDefForPage(
    oldRouter.config,
    oldRouter.pages,
    pageRef,
  )

  const newPattern = MAIN_SLUG_PATTERN

  const newPatternDef = createNewPatternDefinition(
    oldPatternDef,
    newCollectionId,
  )

  const configWithoutOldPattern = deletePattern(oldRouter.config, oldPattern)

  const updatedRouterConfig = addPattern(
    configWithoutOldPattern,
    newPattern,
    newPatternDef,
  )

  return {
    updatedRouterConfig,
  }
}
